import dakor1 from "../../assets/images/dakor-image.jpg";
import dakor2 from "../../assets/images/dakor-image2.jpg";
import dakor3 from "../../assets/images/dakor-image 3.jpg";
import dakor4 from "../../assets/images/dakor-image4.jpg";
import goushala1 from "../../assets/images/goushala1.jpg";
import goushala2 from "../../assets/images/goushala2.jpg";
import goushala3 from "../../assets/images/goushala3.jpg";
import goushala4 from "../../assets/images/goushala4.jpg";
import goushala5 from "../../assets/images/goushala5.jpg";
import goushala6 from "../../assets/images/goushala6.jpg";

export const dakorImages = [
  {
    id: 1,
    image: dakor1,
  },
  {
    id: 2,
    image: dakor2,
  },
  {
    id: 3,
    image: dakor3,
  },
  {
    id: 4,
    image: dakor4,
  },
];

export const goushalImages = [
  {
    id: 1,
    image: goushala1,
  },
  {
    id: 2,
    image: goushala2,
  },
  {
    id: 3,
    image: goushala3,
  },
  {
    id: 4,
    image: goushala4,
  },
  {
    id: 5,
    image: goushala5,
  },
  {
    id: 6,
    image: goushala6,
  },
];
export const dakorInfo = [
  "At the heart of Dakor lies the Ranchhodraiji Temple, a sacred place where Lord Krishna is worshipped in the form of Ranchhodrai. The temple, with its grand architecture and intricate carvings, is a stunning masterpiece that leaves visitors awestruck.",

  "Every year, the temple comes alive with the vibrant colors and sounds of the annual Rath Yatra festival, which is celebrated with great pomp and show. Thousands of devotees flock to the temple to pull the grand chariot through the streets of Dakor, singing and chanting praises of Lord Krishna.",

  "Apart from the Ranchhodraiji Temple, Dakor is also home to several other holy sites that are revered by devotees. The Gomati Kund, a sacred pond that is believed to have been created by Lord Krishna himself, is a serene place that exudes a sense of divine peace and tranquility. The Tulsi Shyam Temple, dedicated to Lord Vishnu, is another beautiful shrine that showcases the town's rich cultural heritage.",

  "For those seeking a spiritual retreat, Dakor is an oasis of calm and serenity. The town's idyllic surroundings and tranquil atmosphere make it an ideal place for meditation and introspection. A visit to Dakor is not just a journey of the body, but also of the soul, as it allows visitors to immerse themselves in the divine presence of Lord Krishna.",

  "In conclusion, Dakor is a magical place that captures the essence of India's rich cultural and spiritual heritage. A visit to this holy town is sure to leave you feeling uplifted and inspired, and you will be mesmerised by its beauty and serenity. So, come and explore the divine wonders of Dakor and experience the timeless enchantment of Lord Krishna's divine abode.",
];

export const goushalaInfo = [
  "The Goverdhan gaushala at ISKCON is a haven for cows, providing them with a safe and loving environment where they can thrive and live out their lives in peace. Located on the grounds of the temple, the gaushala is home to a herd of cows who are treated with the utmost care and respect.",

  "We are currently serving more than 110 Deshi Cows wholeheartedly, where they are brought from surrounding areas sometimes in critical need for care, sometimes being abandoned because they cannot be milked further, and sometimes the caretakers leaving then with us because they cannot keep them anymore",

  "Visitors to the gaushala are immediately struck by the serene and peaceful atmosphere, which is filled with the gentle sound of mooing cows and the rustling of leaves in the breeze. The cows roam freely throughout the spacious grounds, grazing on fresh grass and enjoying the sunshine.",

  "The gaushala is not just a sanctuary for cows, however - it is also a place of learning and inspiration for visitors. Guests can take part in guided tours of the facility, where they can learn about the importance of cow protection and the vital role that cows play in Vedic culture.",
];
